import type { SVGProps } from "react";

export function MingShower(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={props.className}
      {...props}
    >
      <g fill="none">
        <path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" />
        <path
          fill="currentColor"
          d="M12.41 3.654a4.304 4.304 0 0 1 5.571-.661l.18.128l.323.242a3.79 3.79 0 0 1 1.51 2.81l.006.222V21a1 1 0 0 1-1.993.117L18 21V6.395a1.8 1.8 0 0 0-.586-1.325l-.13-.107l-.323-.242a2.3 2.3 0 0 0-2.584-.122l-.153.102l.758.438a4 4 0 0 1 1.566 5.277l-.102.187l-.5.866a1 1 0 0 1-1.261.419l-.105-.053l-8.66-5a1 1 0 0 1-.419-1.262l.053-.104l.5-.866a4 4 0 0 1 5.277-1.565l.187.1zM6.75 15.397a1 1 0 0 1 .366 1.366l-.5.866a1 1 0 0 1-1.732-1l.5-.866a1 1 0 0 1 1.366-.366m2.232.134a1 1 0 0 1 1.785.896l-.053.104l-.5.866a1 1 0 0 1-1.784-.895l.052-.105zm-3.83-3.366a1 1 0 0 1 .366 1.366l-.5.866a1 1 0 1 1-1.732-1l.5-.866a1 1 0 0 1 1.366-.366m3.598-.232a1 1 0 0 1 .366 1.366l-.5.866a1 1 0 0 1-1.732-1l.5-.866a1 1 0 0 1 1.366-.366m2.232.134a1 1 0 0 1 1.785.896l-.053.104l-.5.866a1 1 0 0 1-1.784-.896l.052-.104zm-3.83-3.366a1 1 0 0 1 .366 1.366l-.5.866a1 1 0 1 1-1.732-1l.5-.866a1 1 0 0 1 1.366-.366"
        />
      </g>
    </svg>
  );
}
